import React, { useEffect } from 'react';
import { Checkbox } from '@mui/material';
import { BpIcon, BpCheckedIcon, CheckBoxStyles } from './Styled'
import { Label } from '.';
import { useTheme, } from 'styles';

/**
 * CheckBox (MUI Checkbox wrapper)
 * Boolean checkbox with custom icons and optional label. Designed for form integration
 * via the standard `input` prop (`{ value, onChange }`).
 *
 * Exported as `CheckBox` from `components/Form`. Internal name: `CustomCheckBox`.
 * `onChange` receives the checked boolean directly, not the DOM event.
 * `value` is treated as checked when truthy.
 *
 * @param {Object} props
 * @param {Object} props.input - Form binding: `{ value, onChange }`.
 * @param {boolean} [props.input.value] - Checked state.
 * @param {Function} props.input.onChange - Called with `(checked: boolean)`.
 * @param {string} [props.label] - Optional label rendered via `Label`.
 * @param {boolean} [props.mandatory] - Shows required indicator on the label.
 * @param {string} [props.name] - Native input name.
 * @param {string} [props.className] - Additional CSS class on the checkbox.
 * @example
 * <CheckBox
 *   label="Accept terms"
 *   input={{ value: accepted, onChange: setAccepted }}
 * />
 * @example
 * // Used in form field mapping
 * checkbox: (props) => <CheckBox {...props} />
 */
const CustomCheckBox = (props) => {
    const { label, name, input = {}, className, mandatory, disabled } = props,
        { onChange, value } = input;


    return (
        <CheckBoxStyles>
            <Checkbox
                name={name}
                className={className}
                disabled={disabled}
                checked={value ? true : false}
                onChange={({ target }) => onChange(target.checked)}
                sx={{
                    '&:hover': { bgcolor: 'transparent' },
                }}
                // disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                inputProps={{ 'aria-label': 'Checkbox demo' }}
            />
            {label && <Label className="checkbox-label" label={label} mandatory={mandatory} />}
        </CheckBoxStyles>
    );
}

export default CustomCheckBox